import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TruthSection() {
  return <section className="py-24 md:py-32 bg-[#0f1f38] relative" data-id="element-198">
      <div className="max-w-4xl mx-auto px-6" data-id="element-199">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-200">
          <FadeIn data-id="element-201">
            <h2 className="text-3xl md:text-5xl text-white leading-tight mb-6" data-id="element-202">
              La verdad incómoda{' '}
              <span className="italic text-[#d4af37] block" data-id="element-203">
                (pero liberadora)
              </span>
            </h2>
            <div className="w-20 h-1 bg-[#d4af37] mb-8" data-id="element-204" />
          </FadeIn>

          <FadeIn delay={0.2} className="space-y-6 text-lg text-gray-300" data-id="element-205">
            <p data-id="element-206">
              Dios puede darte convicción… <br data-id="element-207" />
              <strong className="text-white text-xl" data-id="element-208">
                pero tú necesitas un sistema.
              </strong>
            </p>
            <p data-id="element-209">Porque la fe no se prueba en una emoción del domingo.</p>
            <p data-id="element-210">
              Se prueba el martes, con sueño, con estrés, con tentación, con mil
              cosas.
            </p>
            <p className="text-white font-medium border-l-4 border-[#d4af37] pl-4 italic" data-id="element-211">
              Y ahí es donde la mayoría se cae.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}